export const extractResolutionFromUrl = (url: string | null): string | null => {
  if (!url) return null;
  const match = url.match(/(\d{3,4}x\d{3,4})/);
  return match ? match[1] : null;
};
